module.exports = __webpack_public_path__ + "img/34.da6fb9f5.png";